<template>
  <div :class="Class" v-html="svgContent"></div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'

interface Props {
  name: string
  Class?: string
  width?: string
  height?: string
}

const props = defineProps<Props>()
const svgContent = ref<string>('')

const loadSvg = async (name: string) => {
  try {
    const response = await fetch(`/app/svg/${name}.svg`)
    let svg = await response.text()
    svg = svg.replace('<svg', `<svg width="${props.width || '20px'}" height="${props.height || '20px'}"`)
    svgContent.value = svg
  } catch (error) {
    console.error(`Error loading SVG: ${name}`, error)
  }
}

watch(
  () => props.name,
  newName => {
    loadSvg(newName)
  },
  { immediate: true },
)
</script>
